import React, { useCallback } from 'react';
import { Loader } from '../Loader';
export const InfiniteLoad = ({ next }) => {
    const ref = useCallback((node) => {
        if (!node)
            return;
        const observer = new IntersectionObserver((payload) => {
            if (payload[0].isIntersecting) {
                next();
            }
        });
        observer.observe(node);
    }, [next]);
    return (React.createElement("div", { ref: ref },
        React.createElement(Loader, null)));
};
